import styled from "styled-components";

const TOAST_BOTTOM_MARGIN = "100px";
const BUFFER_TOAST_BOTTOM_MARGIN = "30px";
const TOAST_CONTAINER_CLASSNAME = "toast";

export const LoadingContainer = styled.div(({ theme }) => ({
    margin: `calc(${theme.spacing.medium}) 0 0`,
    height: "100%",
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
}));

export const ValidationLoadingContainer = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].canvas_Primary,
    borderRadius: theme.cornerRadius.xLarge,
    padding: `calc(2 * ${theme.spacing.xxLarge}) 0`,
    height: "100%",
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));

export const ToastContainer = styled.div<{ bottomOffset?: number }>(({ theme, bottomOffset = 0 }) => {
    const bottomMargin = bottomOffset ? `${bottomOffset}px + ${BUFFER_TOAST_BOTTOM_MARGIN}` : TOAST_BOTTOM_MARGIN;

    return {
        [`& .${TOAST_CONTAINER_CLASSNAME}`]: {
            bottom: `calc(${bottomMargin})`,
            left: theme.spacing.medium,
            right: theme.spacing.medium,
            marginLeft: "auto",
            marginRight: "auto",
            width: "fit-content",
            maxWidth: `calc(100% - 2 * ${theme.spacing.medium})`,
            zIndex: 2,

            "@supports (bottom: var(--sab))": {
                bottom: `calc(var(--sab) + ${bottomMargin})`,
            },
        },
    };
});
